import { CountryService, ResponseError } from '@ynap/api-utils';
import { timeout, delay } from '@ynap/promise-utils';
import { FETCH_COUNTRY_REQUEST, FETCH_COUNTRY_SUCCESS, FETCH_COUNTRY_ERROR } from '../constants/ActionTypes';

function fetchCountryRequest() {
    return {
        type: FETCH_COUNTRY_REQUEST,
    };
}

function fetchCountrySuccess(country) {
    return {
        type: FETCH_COUNTRY_SUCCESS,
        payload: country,
    };
}

function fetchCountryError() {
    return {
        type: FETCH_COUNTRY_ERROR,
    };
}

export default function fetchCountry() {
    return (dispatch, getState, fetch) => {
        const { config, locale } = getState();
        const { clientRequest } = config.head || config;

        // TODO remove config backwards-compatibility
        const { baseUrl, clientId } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;
        const { country, language } = locale;

        const request = CountryService.getCountry({ baseUrl, brandId, clientId, country, language });

        dispatch(fetchCountryRequest());

        //todo look at if this is shareable across state packages
        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok } = response;

                if (ok) {
                    return response.json().then((json) => dispatch(fetchCountrySuccess(json)));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(fetchCountryError(error));
                throw error;
            });
    };
}
